var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"menu"}},_vm._l((_vm.navList),function(item){return _c('li',{key:("" + (item.id))},[[_c('router-link',{attrs:{"to":("" + (item.url))}},[_vm._v(" "+_vm._s(item.name)+" ")])]],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }